var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-progress__container"},[_c('span',{staticClass:"global-progress__progress",style:({ transform: 'scaleX(' + _vm.value + ')' }),attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"global-progress__background",attrs:{"aria-hidden":"true"}}),_c('progress',{staticClass:"global-progress",domProps:{"value":_vm.value,"textContent":_vm._s(_vm.progress)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0af20569","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheProgress.vue
// module id = null
// module chunks = 